module.exports = __webpack_public_path__ + "assets/img/btn3.3c26e3db.png";